import client from 'data/client';
import { GeneralSettingsData } from 'data/types/settings';
import { normalizeGeneralSettings } from 'model/settings';

const getGeneralSettings = async () => {
  const response = await client.get<GeneralSettingsData>(`/settings/general`);
  return normalizeGeneralSettings(response.data);
};

export default getGeneralSettings;
